import React from "react";
import { Popover } from "antd";
import { TooltipPlacement } from "antd/lib/tooltip/index";

interface IPopoverWithoutOptions {
  visible?: boolean;
  placement?: TooltipPlacement;
  content?: string;
  onVisibleChange?: any;
  trigger?: string;
  overlayClassName?: string;
}
//Popup component intended for containing content sharing options on social media

const PopoverWithoutOptions: React.FC<IPopoverWithoutOptions> = (props) => {
  return (
    <Popover
      overlayInnerStyle={{ borderRadius: 10 }}
      visible={props?.visible}
      content={props?.content}
      onVisibleChange={props?.onVisibleChange}
      placement={props?.placement}
      trigger={props?.trigger}
      overlayClassName={props?.overlayClassName}
      getPopupContainer={() => document.querySelectorAll(".content-inner")[0] as HTMLElement}
    >
      {/* {console.log("wrappergetelement", document.querySelectorAll(".share-wrapper")[0])} */}
      {props.children}
    </Popover>
  );
};

export default PopoverWithoutOptions;

PopoverWithoutOptions.defaultProps = {
  placement: "leftTop",
  trigger: "click",
  overlayClassName: "BlogPopover",
};
